import React from 'react';
import { formatBackendEnumLabel, formatPlayerRoleLabel } from '../../../../helper/helper';
import { Images } from '../../../../utils/imageConstants';
import type { IPlayerByLeagueForRequest } from '../types/request';

interface AllPlayersCardProps {
  player: IPlayerByLeagueForRequest;
}

export const AllPlayersCard: React.FC<AllPlayersCardProps> = ({ player }) => {
  const fullName =
    [player.playerFirstName, player.playerLastName].filter(Boolean).join(' ') || '-';
  const teamId =
    player.teamCode ?? player.teamSnapshotId ?? player.playerId ?? '';
  const playerId = player.playerId ?? '';
  const role = formatPlayerRoleLabel(player.playerRole ?? '-');
  const batting = formatBackendEnumLabel(player.battingStyle ?? '-');
  const bowling = formatBackendEnumLabel(player.bowlingStyle ?? '-');

  const imageUri = player.imageUri;
  const cdnBaseUrl = import.meta.env.VITE_IMAGE_CDN_BASE_URL;
  const avatarSrc =
    imageUri && cdnBaseUrl
      ? `${cdnBaseUrl.replace(/\/$/, '')}/${imageUri.replace(/^\//, '')}`
      : Images.team_member_placeholder;

  return (
    <div className="all-players-card">
      <div className="all-players-card-header">
        <div className="all-players-card-avatar">
          <img src={avatarSrc} alt="" />
        </div>
        <div className="all-players-card-title-block">
          <span className="all-players-card-name">{fullName}</span>
          {teamId && (
            <span className="all-players-card-team-id">
              Player ID : {playerId}
            </span>
          )}
          <div className="all-players-card-attributes">
            <div className="all-players-card-col">
              <span className="all-players-card-label">Role:</span>
              <span className="all-players-card-value">{role}</span>
            </div>
            {/* <div className="all-players-card-col all-players-card-col-sep">
          <span className="all-players-card-label">Batting Style:</span>
          <span className="all-players-card-value">{batting}</span>
        </div>
        <div className="all-players-card-col all-players-card-col-sep">
          <span className="all-players-card-label">Bowling Style:</span>
          <span className="all-players-card-value">{bowling}</span>
        </div> */}
          </div>
        </div>
      </div>

      <div className="all-players-card-actions">
        <button type="button" className="all-players-card-btn-primary">
          Add Role
        </button>
        <button type="button" className="all-players-card-btn-outline">
          Merge
        </button>
      </div>
    </div>
  );
};
